import React from "react";
import Icon from "./Icon";

export default function Footer({ data, onContact }) {
  return (
    <>
      <footer className="footer" id="contact">
        <div>
          <h2 className="footer-h">Let's talk.</h2>
          <div className="footer-sub">Replies within a day, usually less.</div>
        </div>
        <button className="btn btn-primary" onClick={onContact}>
          <Icon name="mail" size={16} /> {data.links[0].label}
        </button>
      </footer>
      <div className="footer-fine">
        © {new Date().getFullYear()} {data.name}
      </div>
    </>
  );
}
